<template>
  <div>
    <section class="partner-manager-edit ly-edit">
      <div class="section-inner">
        <div class="section-cont">
          <h2>제휴문의 담당자 관리</h2>
          <p class="site-path">
            <span>Home</span>&nbsp;&gt;&nbsp;
            <span>PRODUCTS</span>&nbsp;&gt;&nbsp;
            <span>제휴문의 담당자 관리</span>
          </p>
          <table>
            <colgroup>
              <col class="col1" />
              <col class="col2" />
            </colgroup>
            <tr>
              <th scope="row">
                <label for="store-manager-name">담당자</label>
              </th>
              <td>
                <input
                  type="text"
                  id="store-manager-name"
                  name="store-manager-name"
                  value="담당자 명이 표시됩니다"
                  v-model="name"

                />
              </td>
            </tr>
            <tr>
              <th scope="row">
                <label for="store-manager-num">연락처</label>
              </th>
              <td>
                <input
                  type="text"
                  id="store-manager-num"
                  name="store-manager-num"
                  value="연락처가 표시됩니다"
                  v-model="mobile_no"
                />
              </td>
            </tr>
            <tr>
              <th scope="row">
                <label for="store-manager-email">이메일</label>
              </th>
              <td>
                <input
                  type="text"
                  id="store-manager-email"
                  name="store-manager-email"
                  value="이메일이 표시됩니다"
                  v-model="email"

                />
              </td>
            </tr>
          </table>
          <!-- /.table-->

          <router-link
            :to="{ name: 'PartnershipManagerList' }"
            class="btn-white"
            >목록</router-link
          >
          <button class="btn-blue btn-right" @click="onSubmitModify">수정</button>
          <!-- /.btn -->
        </div>

        <app-footer />
      </div>
    </section>
  </div>
</template>

<script>
import AppFooter from "../../AppFooter.vue";
import mananger_handle_mixin from '../../../mixins/managerHandle_mixin'; 

export default {
  props: ["id", "item"],
  components: { AppFooter },
  name: "PartnershipManagerEdit",
  mixins: [mananger_handle_mixin],
  data() {
    return {
      taskpart: 'partnership',
    }   
  },
  created() {
    console.log('PartnershipManagerEdit created => ', this.id , this.item );
    this.name = this.item.name ; 
    this.mobile_no = this.item.mobile_no ; 
    this.email = this.item.email ; 
  },
  methods: {
    onSubmitModify() {
      this.reqUpdateManager( 
        {
          taskpart: this.taskpart ,
          id: this.item.id, 
          name: this.name ,
          mobile_no : this.mobile_no,
          email: this.email 
        }
      );      
    },
  },



};
</script>
